import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container
} from "react-bootstrap";
import { appConfig } from "../../config";
var dateFormat = require("dateformat");

var moment = require("moment");
require("moment-duration-format");

class DistributorDetailView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

convertTime=(timefetched)=>{

  let hours = Math.floor(timefetched/60);
  let AmOrPm = hours >= 12 ? 'pm' : 'am';
  let minutes = timefetched - (hours*60);
  minutes = (minutes>10?minutes:"0"+minutes);
  return hours > 12
      ? hours - 12 + ":" + minutes + " " + AmOrPm
      : hours + ":" + minutes + " " + AmOrPm;
  };

  getName = (value) => {
    return value && value.name ? value.name : "";
  };

  getWorkingHours = (day) => {
    return day && day.open !== undefined && day.open !== null
      ? this.convertTime(day.open) + " to " + this.convertTime(day.close)
      : "Holiday";
  };


  render() {

    const data =
      this.props.distributortoView && this.props.distributortoView.item
        ? this.props.distributortoView.item
        : null;

    const details = this.props.distributorDetail
      ? this.props.distributorDetail
      : null;
    const distributorUsers = this.props.distributorUsers
      ? this.props.distributorUsers
      : [];
    const distributorUsersLoading = this.props.distributorUsersLoading;
      
    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.close}
            animation={false}
            className="detailModal"
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Distributor Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <div className="storeNavdiv">
                  <Nav variant="pills">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Basic Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Contact Info</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">More</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="fourth">Users</Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
                <Tab.Content style={{ border: "none" }}>
                  <Tab.Pane eventKey="first">
                    <div className="storeModalTbl">
                      <Table responsive bordered className="cmnMainTable">
                        <tbody>
                          <tr>
                            <td className="storeTdWdth">Organization Name</td>
                            <td className="storeModalCap">
                              {details !== null && details.name}
                            </td>
                          </tr>
                        
                          <tr>
                            <td>Address1</td>
                            <td className="storeModalCap">
                              {details !== null && details.addr1}
                            </td>
                          </tr>
                          <tr>
                            <td>Address2</td>
                            <td className="storeModalCap">
                              {details !== null && details.addr2}
                            </td>
                          </tr>
                          <tr>
                            <td>Delivery </td>
                            <td className="storeModalCap">
                              {details !== null &&
                              details.homeDlry !== undefined &&
                              details.homeDlry
                                ? "Home Delivery"
                                : "Store Pickup"}
                            </td>
                          </tr>

                          <tr>
                            <td> Country</td>
                            <td className="feedbkModalCap">
                              {details !== null && this.getName(details.country)}
                            </td>
                          </tr>
                          <tr>
                            <td> State</td>
                            <td className="feedbkModalCap">
                              {details !== null && this.getName(details.state)}
                            </td>
                          </tr>
                          <tr>
                            <td> District</td>
                              <td className="feedbkModalCap">
                              {details !== null && this.getName(details.district)}
                            </td>
                          </tr>
                          <tr>
                            <td>Landmark</td>
                            <td className="storeModalCap">
                              {details !== null && details.landmark}
                            </td>
                          </tr>
                          <tr>
                            <td>City</td>
                            <td className="storeModalCap">
                              {details !== null && details.city}
                            </td>
                          </tr>

                          <tr>
                            <td>Zip Code</td>
                            <td className="storeModalCap">
                              {details !== null && details.zip}
                            </td>
                          </tr>
                          <tr>
                            <td>GST</td>
                            <td className="storeModalCap">
                              {details !== null && details.gstin}
                            </td>
                          </tr>
                          <tr>
                            <td>Drug License(20B)</td>
                            <td className="storeModalCap">
                              {details !== null && details.licenceNo}
                            </td>
                          </tr>
                          <tr>
                            <td>Drug License(21B)</td>
                            <td className="storeModalCap">
                              {details !== null && details.drugLicense}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="second">
                    <div className="storeSecndModalTbl">
                      <Table responsive bordered  className="cmnMainTable">
                        <tbody>
                          <tr>
                            <td>Contact Person</td>
                            <td className="storeModalCap">
                              {details !== null && details.contactPersn}
                            </td>
                          </tr>
                          <tr>
                            <td> Mobile Number</td>
                            <td className="storeModalCap">
                              {details !== null &&
                                details.userId &&
                                details.userId.mobileNo}
                            </td>
                          </tr>
                          <tr>
	                            <td>Organization ID</td>
	                            <td className="storeModalCap">
	                              {details !== null &&
	                                details.userId &&
	                                details.userId.orgId}
	                            </td>
	                          </tr>

                          <tr>
                            <td>Email</td>
                            <td> {details !== null && details.email}</td>
                          </tr>
                          <tr>
                            <td>Website</td>
                            <td>{details !== null && details.website}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </Tab.Pane>

	                  <Tab.Pane eventKey="third">
                    <div className="storeModalTbl">
                      <Table responsive bordered className="cmnMainTable">
                        <tbody>
                           <tr>
                            <td>Working Hours</td>
                            <td>
                              <p>
                                Mon &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.mon
                                )}
                              </p>
                              <p>
                                Tue &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.tue
                                )}
                              </p>
                              <p>
                                Wed &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.wed
                                )}
                              </p>
                              <p>
                                Thu &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.thu
                                )}
                              </p>
                              <p>
                                Fri &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.fri
                                )}
                              </p>
                              <p>
                                Sat &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.sat
                                )}
                              </p>
                              <p>
                                Sun &nbsp;
                                {this.getWorkingHours(
                                  details &&
                                    details.workingHrs &&
                                    details.workingHrs.sun
                                )}
                              </p>
                            </td>
                          </tr>

                          <tr>
                            <td>Logo</td>
                            <td className="storeModalCap">
                              <div className="storeImgDiv">
                                <Image
                                  className="storeImg"
                                  src={[
                                    details && details.imgUrl !== undefined
                                      ? appConfig.ip + "/attachments/preview/" +encodeURIComponent(details.imgUrl) 
                                      : require("../../assets/img/defaultPic.jpg")
                                  ]}
                                />
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td className="storeTdWdth">Created Date</td>
                            <td className="storeModalCap">
                              {data !== null &&
                                data.createdAt !== null &&
                                dateFormat(data.createdAt, "mediumDate")}
                            </td>
                          </tr>

                          <tr>
                            <td className="storeTdWdth">Updated Date</td>
                            <td className="storeModalCap">
                              {data !== null &&
                                data.updatedAt !== null &&
                                dateFormat(data.updatedAt, "mediumDate")}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
	                  </Tab.Pane>
                  <Tab.Pane eventKey="fourth">
                    <div className="storeModalTbl">
                      <Table responsive bordered className="cmnMainTable">
                        <thead>
                          <tr>
                            <th>Full Name</th>
                            <th>Role</th>
                          </tr>
                        </thead>
                        <tbody>
                          {distributorUsersLoading && (
                            <tr>
                              <td colSpan={2} style={{ textAlign: "center" }}>
                                Loading...
                              </td>
                            </tr>
                          )}

                          {!distributorUsersLoading &&
                            distributorUsers.length > 0 &&
                            distributorUsers.map((user, i) => (
                              <tr key={i}>
                                <td className="storeModalCap">
                                  {user && user.fullName ? user.fullName : ""}
                                </td>
                                <td className="storeModalCap">
                                  {user && user.role ? user.designation : ""}
                                </td>
                              </tr>
                            ))}

                          {!distributorUsersLoading &&
                            distributorUsers.length === 0 && (
                              <tr>
                                <td
                                  colSpan={2}
                                  style={{ textAlign: "center" }}
                                >
                                  No users under this distributor
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </Table>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default DistributorDetailView;
